import { render } from "./TenantKeywordManagement.vue?vue&type=template&id=1083e136&scoped=true"
import script from "./TenantKeywordManagement.vue?vue&type=script&lang=js"
export * from "./TenantKeywordManagement.vue?vue&type=script&lang=js"

import "./TenantKeywordManagement.vue?vue&type=style&index=0&id=1083e136&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1083e136"]])

export default __exports__